




























































import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import "./modal-gallery.less";

@Component({
  components: {}
})
export default class ModalGallery extends Vue {
  @Prop() images;
  @Prop() visible;
  @Prop() index;
  @Prop() galleryNumber;
  @Prop() isMobile;
  @Prop() useThumbnails;

  private data = {
    visible: true
  };
  private isThumbnailDots = false; // FIXME: egy beállítástól kellene függővé tenni ami a pb componentrből jön le

  mounted() {
    this.data.visible = this.visible;
    let self = this;
    this.isThumbnailDots = this.useThumbnails==1 ? true : false;
  }
  counterReposition(){
    var width = window.innerWidth;
    let self = this;
    let container = $('#modalGallery'+this.galleryNumber).find(".slick-active .modal-gallery-image-container");
    let imagePosition = container.find("img").eq(0).offset();
    let imageCaptionNode = $('#modalGallery'+this.galleryNumber).find(".slick-active .image-caption-container");
    container.find('p.mobilecounter').css('margin-top',((container as any).find('img').height()/2+20)+'px');
    if(!imageCaptionNode.hasClass('mobilecounter')){
      imageCaptionNode.css('padding-left',(imagePosition!.left - 80 )+'px');
    }
    if(self.isThumbnailDots){
      $('#modalGallery'+this.galleryNumber).find('.slick-dots').css('top',self.getDotsTop()+'px');
    }
  }
  updated() {
    this.data.visible = this.visible;
  }
  getDotsTop(){
    var width = window.innerWidth;
    if (width >= 600) {
      return -45;
    } else if (width <= 599) {
      return -20;
    }
  }

  @Watch("visible", { immediate: true, deep: true })
  onVisible(visible) {
    let self = this;
    this.data.visible = visible;
    if (visible) {
      setTimeout(function() {
         $('#modalGallery'+self.galleryNumber).find(".modal-gallery-slick-slider-list").off("afterChange").on("afterChange",function(a,b,c,d){
           setTimeout(function(){
            self.counterReposition();
            ($('#modalGallery'+self.galleryNumber).find(".slick-active p.image-caption-container") as any).show();
           },200);
        });
         $('#modalGallery'+self.galleryNumber).find(".modal-gallery-slick-slider-list").off("beforeChange").on("beforeChange",function(a,b,c,d){
          ($('#modalGallery'+self.galleryNumber).find("p.image-caption-container") as any).hide();
        });
        self.initCarusel();
      }, 200);
    } else {
      this.destroyCarusel();
    }
  }
  @Watch("index", { immediate: true, deep: true })
  onIndex(index) {
    let self = this;
    setTimeout(function() {
      try {
        ($('#modalGallery'+self.galleryNumber).find(".modal-gallery-slick-slider-list") as any).slick(
          "slickGoTo",
          index
        );
      } catch (e) {}
    }, 200);
  }


  refreshCarusel() {
    this.destroyCarusel();
    this.initCarusel();
  }

  closeModal() {
    this.data.visible = false;
    this.onSettingVisible(false);
    this.destroyCarusel();
  }

  galleryResize() {
    var width = window.innerWidth;
    var height = window.innerHeight;
    let self = this;

    if (width >= 960) {
      $('#modalGallery'+this.galleryNumber).find(".modal-gallery-image-container").height(height - 180);
    } else if (width >= 600 && width <= 959) {
      $('#modalGallery'+this.galleryNumber).find(".modal-gallery-image-container").height(height - 140);
    } else if (width <= 599) {
      $('#modalGallery'+this.galleryNumber).find(".modal-gallery-image-container").height(height - 80);
    }
    self.counterReposition();
  }

  initCarusel() {
    let self = this;
    try {
      ($('#modalGallery'+this.galleryNumber).find(".modal-gallery-slick-slider-list") as any).slick({
        dots: self.isThumbnailDots, 
        customPaging: function(slider, i) { 
          return '<img class="tab" src="'+ self.images[i].thumbnailImage+'">';
        },
        infinite: true,
        centerMode: false,
        rows: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: "ondemand",
        prevArrow:
          '<a class="carousel-control-prev gallery-button" href="#gallery'+this.galleryNumber+'" role="button" data-slide="prev"><span class="mdi mdi-chevron-left"></span></a>',
        nextArrow:
          '<a class="carousel-control-next gallery-button" href="#gallery'+this.galleryNumber+'" role="button" data-slide="next"><span class="mdi mdi-chevron-right"></span></a>',
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: self.isThumbnailDots
            }
          }
        ]
      });
      this.galleryResize();
    } catch (ex) {}
    try {
      let self = this;
      window.addEventListener("resize", this.galleryResize);
      window.addEventListener("orientationchange", this.galleryResize);
      $(document).bind('keyup', function(e) {
        if (e.keyCode==37) {
          $('#modalGallery'+self.galleryNumber).find('.carousel-control-prev').trigger('click');
        } else if(e.keyCode==39){
          $('#modalGallery'+self.galleryNumber).find('.carousel-control-next').trigger('click');
        }
      });
    } catch (e) {}
  }

  destroyCarusel() {
    try {
      ($('#modalGallery'+this.galleryNumber).find(".modal-gallery-slick-slider-list") as any).slick("destroy");
    } catch (ex) {}
  }


  @Emit("settingVisible")
  onSettingVisible(value) {}
}
